<template>
  <div class="home" :class="sections.array[sections.counter].clase">
    <transition :name="sectionAnim" mode="out-in">
      <component :is="sections.array[sections.counter].name" ></component>
    </transition>
    <switcher/>
  </div>
</template>
<script>
import heading from './Header'
import nosotros from './Nosotros'
import contacto from './Contacto'
import equipo from './Equipo'
import fabrica from './Fabrica'
import portfolio from './Portfolio'
import switcher from '@/components/switcher'
import sideNav from '@/components/sideNav'
import mixins from '@/mixins/mixins'


export default {
  name: 'home',
  components: {
    nosotros,
    contacto,
    equipo,
    fabrica,
    portfolio,
    heading,
    switcher,
    sideNav
  },
  mixins: [
    mixins
  ],
  computed: {
    sections () {
      return this.$store.state.sections
    },
    sectionAnim () {
      return this.$store.state.sectionAnim
    }
  },
  mounted () {
    this.$route.params.section ? this.navigateTo(4) : null;
  }
}
</script>
